import { render, staticRenderFns } from "./PasteKeyHandler.vue?vue&type=template&id=3c10c99d&"
import script from "./PasteKeyHandler.vue?vue&type=script&lang=ts&"
export * from "./PasteKeyHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports